import { c as _c } from "react/compiler-runtime";
import { IconButton } from '@repo/design-system/components/ds/button';
import { Icon } from '@repo/design-system/components/ds/icon';
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { FlexRow } from '@repo/design-system/components/layout/flex-row';
import { Type } from '@repo/design-system/components/ui/type';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import type React from 'react';
interface HiddenPinsCardProps {
  hiddenCount: number;
  onShow: () => void;
  onDismiss: () => void;
}
const cardContainerStyles = css.raw({
  backdropFilter: '[blur(16px)]',
  backgroundColor: 'whiteAlpha.5',
  borderRadius: '12',
  padding: '12',
  transition: 'colors',
  _hover: {
    backgroundColor: 'whiteAlpha.10'
  },
  _focusWithin: {
    backgroundColor: 'whiteAlpha.10'
  }
});
const ctaButtonStyles = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '4',
  flex: '1',
  minWidth: '[0]',
  background: 'transparent',
  border: 'none',
  padding: '0',
  margin: '0',
  textAlign: 'left',
  cursor: 'pointer',
  _focusVisible: {
    outline: 'none'
  }
});
export const HiddenPinsCard: React.FC<HiddenPinsCardProps> = t0 => {
  const $ = _c(25);
  const {
    hiddenCount,
    onShow,
    onDismiss
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["game_map"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useT(t1);
  let t2;
  if ($[1] !== hiddenCount || $[2] !== t) {
    t2 = hiddenCount === 1 ? t(_temp) : t(_temp2, {
      count: hiddenCount
    });
    $[1] = hiddenCount;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const bodyText = t2;
  let t3;
  if ($[4] !== bodyText) {
    t3 = <Type variant="body-xs" color="text.secondary">{bodyText}</Type>;
    $[4] = bodyText;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t(_temp3);
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <Type variant="caption" color="text.primary">{t4} →</Type>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <FlexColumn gap="4" align="start" width="full">{t3}{t5}</FlexColumn>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== onShow || $[14] !== t6) {
    t7 = <button type="button" className={ctaButtonStyles} onClick={onShow}>{t6}</button>;
    $[13] = onShow;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t(_temp4);
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Icon icon="close" decorative={true} />;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== onDismiss || $[20] !== t8) {
    t10 = <IconButton variant="ghost" onClick={onDismiss} color="secondary" size="sm" aria-label={t8}>{t9}</IconButton>;
    $[19] = onDismiss;
    $[20] = t8;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t7) {
    t11 = <FlexRow align="center" gap="8" width="full" className={cardContainerStyles}>{t7}{t10}</FlexRow>;
    $[22] = t10;
    $[23] = t7;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
};
function _temp($) {
  return $.one_pin_hidden_by_filters;
}
function _temp2($_0) {
  return $_0.$count_pins_hidden_by_filters;
}
function _temp3($_1) {
  return $_1.show_hidden_pins;
}
function _temp4($_2) {
  return $_2.close;
}